import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiaryDetailsChanges } from '../../models/beneficiary-details-changes';
import { BeneficiarySubmissionUtils } from '../../utils/beneficiary-submission-utils';
import { SubmissionDetailsFieldChange } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change';
import { SubmissionDetailsFieldChangesComponent } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-changes.component';
import { SubmissionDetailsFieldChangeTypeEnum } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change-type.enum';

@Component({
  selector: 'app-beneficiary-details-estate-changes',
  standalone: true,
  imports: [CommonModule, SubmissionDetailsFieldChangesComponent],
  templateUrl: './beneficiary-details-estate-changes.component.html',
  styleUrls: [
    '../../../../views/shared/components/member-beneficiary-submission-details/member-beneficiary-submission-details.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiaryDetailsEstateChangesComponent implements OnChanges {
  // An estate's primary contact can be either an individual or an organization; the fields shown depend on which.
  private static readonly individualContactKeys = ['firstName', 'lastName', 'phoneNumber'];
  private static readonly organizationContactKeys = [
    'organizationName',
    'organizationPhoneNumber',
    'address.addressLine1',
    'address.addressLine2',
    'address.addressLine3',
    'address.city',
    'address.state',
    'address.country',
    'address.postalCode'
  ];

  @Input() beneficiaryChanges!: BeneficiaryDetailsChanges;

  public contactPrevious: SubmissionDetailsFieldChange[] = [];
  public contactNew: SubmissionDetailsFieldChange[] = [];
  public contactPreviousNotApplicable = false;
  public contactNewNotApplicable = false;
  public contactSectionHidden = false;

  public ngOnChanges(): void {
    const { previous, new: newChanges } = this.beneficiaryChanges;

    const contactPrevious = BeneficiarySubmissionUtils.toDetailsSection(previous, this.contactKeysFor(previous));
    const contactNew = BeneficiarySubmissionUtils.toDetailsSection(newChanges, this.contactKeysFor(newChanges));

    this.contactPrevious = contactPrevious.items;
    this.contactNew = contactNew.items;
    this.contactPreviousNotApplicable = contactPrevious.notApplicable;
    this.contactNewNotApplicable = contactNew.notApplicable;
    this.contactSectionHidden = contactPrevious.notApplicable && contactNew.notApplicable;
  }

  private contactKeysFor(changes: SubmissionDetailsFieldChange[]): string[] {
    const hasIndividualContact = !!changes.find(change => change.key === 'firstName')?.value;
    return hasIndividualContact
      ? BeneficiaryDetailsEstateChangesComponent.individualContactKeys
      : BeneficiaryDetailsEstateChangesComponent.organizationContactKeys;
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
